import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {TakeUntilDestroy} from "../../../../core/component/take-until-destroy";

@Component({
    selector: 'accordion-form-section',
    templateUrl: './accordion-form-section.component.html',
    styleUrls: ['./accordion-form-section.component.scss'],
    standalone: false
})
export class AccordionFormSectionComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  @Input() expanded = false;
  @Input() title: string;

  @HostBinding('class.form-section-expanded') panelOpenState: boolean = this.expanded;

  constructor() {
    super();
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
